<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
    name: 'App',
    components: {
      
    }
  }
</script>

<!-- Estilos Globales -->
<style>
  /*  Fondo de las vistas  */
  .fondovista {
    margin-top: 55px;
    background-color: #ebedef;
  }

  /*  Pie de las Vistas  */
  .piepagina {
    margin-top: 10px;
    margin-bottom: 10px;
    text-align: center;
  }

  /*  Animación  */
  .slide-fade-enter-active {
    transition: all .8s ease;
  }
  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(50px);
    opacity: 0;
  }
</style>